/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Skeleton from "./Skeleton";
import { textSizeStyles } from "../ui/Text";
import { titleSizeStyles } from "../ui/Title";

// Each line takes the real text's line-height, so the block is as tall as the text it stands in for.
const Lines = styled.div`
  ${({ $size }) => titleSizeStyles[$size] || textSizeStyles[$size]}
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => $width};
`;

const Line = styled(Skeleton)`
  height: 0.75em;
  margin-block: calc((1lh - 0.75em) / 2);
`;

const SkeletonText = ({ size = "default", lines = 1, width = "100%", lastLineWidth = "60%", className }) => (
  <Lines $size={size} $width={width} className={className} aria-hidden="true">
    {Array.from({ length: lines }, (_, index) => (
      <Line key={index} borderRadius={4} width={lines > 1 && index === lines - 1 ? lastLineWidth : "100%"} />
    ))}
  </Lines>
);

export default SkeletonText;
